import React, { useState, useEffect } from 'react'
import { View } from 'react-native'
import PropTypes from 'prop-types'
import { Colors, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'
import moment from 'moment'
import ContentLoader, { Rect } from 'react-content-loader/native'

import VfText from '../VfText'

import styles from './Countdown.Styles'

const DEFAULT_COUNTDOWN = {
  hours: '00',
  minutes: '00',
  seconds: '00',
}

const getTime = (to, format) => {
  if (!to || !format) {
    return DEFAULT_COUNTDOWN
  }

  const diff = moment.duration(moment(to, format).diff(moment()))

  if (diff.asSeconds() < 0) {
    return DEFAULT_COUNTDOWN
  }
  const minutes = (diff.minutes() + '').padStart(2, '0'),
    seconds = (diff.seconds() + '').padStart(2, '0')
  let hours = diff.hours()

  // if (days === 1) {
  //   hours += 24
  // }
  hours = (hours + '').padStart(2, '0')

  return {
    hours,
    minutes,
    seconds,
  }
}

function CountdownPlaceholder({
  theme,
}) {
  const {
    background,
    foreground,
  } = theme


  return (
    <View style={styles.container}>
      <View style={styles.sectionCentered}>
        <ContentLoader
          speed={0.6}
          width={35}
          height={35}
          backgroundColor={background}
          foregroundColor={foreground}
          style={styles.loaderContainer}
        >
          <Rect x="0" y={0} rx="6" ry="6" width={35} height={35} />
        </ContentLoader>
        <ContentLoader
          speed={0.6}
          width={35}
          height={10}
          backgroundColor={background}
          foregroundColor={foreground}
          style={styles.loaderContainer}
        >
          <Rect x="0" y={0} rx="6" ry="6" width={35} height={10} />
        </ContentLoader>
      </View>

      <ContentLoader
        speed={0.6}
        width={10}
        height={25}
        backgroundColor={background}
        foregroundColor={foreground}
        style={styles.loaderContainer}
      >
        <Rect x="0" y={0} rx="6" ry="6" width={10} height={25} />
      </ContentLoader>

      <View style={styles.sectionCentered}>
        <ContentLoader
          speed={0.6}
          width={35}
          height={35}
          backgroundColor={background}
          foregroundColor={foreground}
          style={styles.loaderContainer}
        >
          <Rect x="0" y={0} rx="6" ry="6" width={35} height={35} />
        </ContentLoader>
        <ContentLoader
          speed={0.6}
          width={35}
          height={10}
          backgroundColor={background}
          foregroundColor={foreground}
          style={styles.loaderContainer}
        >
          <Rect x="0" y={0} rx="6" ry="6" width={35} height={10} />
        </ContentLoader>
      </View>

      <ContentLoader
        speed={0.6}
        width={10}
        height={25}
        backgroundColor={background}
        foregroundColor={foreground}
        style={styles.loaderContainer}
      >
        <Rect x="0" y={0} rx="6" ry="6" width={10} height={25} />
      </ContentLoader>

      <View style={styles.sectionCentered}>
        <ContentLoader
          speed={0.6}
          width={35}
          height={35}
          backgroundColor={background}
          foregroundColor={foreground}
          style={styles.loaderContainer}
        >
          <Rect x="0" y={0} rx="6" ry="6" width={35} height={35} />
        </ContentLoader>
        <ContentLoader
          speed={0.6}
          width={35}
          height={10}
          backgroundColor={background}
          foregroundColor={foreground}
          style={styles.loaderContainer}
        >
          <Rect x="0" y={0} rx="6" ry="6" width={35} height={10} />
        </ContentLoader>
      </View>

    </View>
  )
}
CountdownPlaceholder.propTypes = {
  theme: PropTypes.object,
}

function Countdown({ to, format, isContentLoading }) {
  const [loading, setLoading] = useState(true)
  const [count, setCount] = useState(() => getTime(to, format))

  const theme = useTheme()

  useEffect(() => {
    const interval = setInterval(() => {
      setCount(() => getTime(to, format))
      setLoading(false)
    }, 1000)

    if (to && format) {
      setCount(getTime(to, format))
      setLoading(false)
    }

    return () => {
      clearInterval(interval)
    }
  }, [format, to])

  const cLoaderColors = {
    background: theme.colors.shimmerCenterColor,
    foreground: theme.colors.shimmerEdgesColor,
  }

  return (
    <>
      {(isContentLoading || loading) ?
        <CountdownPlaceholder theme={cLoaderColors} />
        : <View style={styles.container}>
          <View style={styles.sectionCentered}>
            <VfText
              i18nKey={count.hours}
              size="h1"
              weight="bold"
              color={theme.colors.textColor}
            />
            <VfText
              i18nKey="vday_hour"
              translateOption={{ count: count?.days }}
              color={theme.colors.textColor}
              style={styles.smallLabel}
            />
          </View>
          <VfText
            i18nKey=":"
            size="h3"
            color={theme.colors.textColor}
          />
          <View style={styles.sectionCentered}>
            <VfText
              i18nKey={count.minutes}
              size="h1"
              weight="bold"
              color={theme.colors.textColor}
            />
            <VfText
              i18nKey="vday_minute"
              color={theme.colors.textColor}
              style={styles.smallLabel}
            />
          </View>
          <VfText
            i18nKey=":"
            size="h3"
            color={theme.colors.textColor}
          />
          <View style={styles.sectionCentered}>
            <VfText
              i18nKey={count.seconds}
              size="h1"
              weight="bold"
              color={theme.colors.textColor}
            />
            <VfText
              i18nKey="vday_second"
              color={theme.colors.textColor}
              style={styles.smallLabel}
            />
          </View>

        </View>}
    </>
  )
}

Countdown.defaultProps = {

}

Countdown.propTypes = {
  to: PropTypes.string.isRequired,
  format: PropTypes.string.isRequired,
  isContentLoading: PropTypes.bool,
}

export default Countdown
